import { makeAutoObservable, runInAction } from "mobx";
import { IInfoSection, IInfoSectionsResponse } from "../../../types/common";
import http from "../../../libs/http";

class AboutPageStore {
  sectionsInfo?: IInfoSection[] = undefined;
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchSections() {
    this.startLoading();
    const { data } = await http.get<IInfoSectionsResponse>(
      "/api/info-sections"
    );

    if (data.success && data.sections) {
      runInAction(() => {
        this.sectionsInfo = data.sections;
      });
    }
    this.finishLoading();
  }

  getSection(key: string) {
    if (this.sectionsInfo) {
      return   this.sectionsInfo.find((i) => i.key == key)?.content;
    }
    return undefined;
  }

  startLoading() {
    runInAction(() => {
      this.isLoading = true;
    });
  }

  finishLoading() {
    runInAction(() => {
      this.isLoading = false;
    });
  }
}

export default new AboutPageStore();
